// 日志管理：
// 行为记录：测试环境使用console.log；生产环境使用日志上传；
// 报错和异常：不管任何报错都console.error, console.error 会被sentry捕获。

var reg = /\.umu\.(cn|com|co|io|tw)/i;
// 判断是否是生产环境
function isProduction() {
    return reg.test(window.location.href);
}

function getUserInfo() {
    var userInfo = (window.pageData && window.pageData.data && window.pageData.data.user_info) || {};
    return {
        uid: userInfo.umu_id || '',
        eid: userInfo.enterprise_id || '',
    };
}

function getLogUrl() {
    var domain = '';
    var match = window.location.href.match(reg);
    if (match && match[1]) {
        domain = match[1];
    }
    var logUrl = '';
    if (domain) {
        logUrl = `https://log.umu.${domain}/hm2.gif`;
    }
    return logUrl;
}

var isEnableLog = window.isEnableLog || !isProduction();
var logUrl = getLogUrl();
var userInfo = getUserInfo();

function setQueryParams(params) {
    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            var value = params[key];
            if (typeof value === 'object' && value !== null) {
                try {
                    params[key] = JSON.stringify(value);
                } catch (error) {
                    console.error('setQueryParams error', error);
                    continue;
                }
            }
        }
    }
    // 将params对象转换为查询字符串
    var queryString = Object.entries(params)
        .map(function ([key, value]) {
            return `${key}=${value}`;
        })
        .join('&');
    return encodeURIComponent(queryString);
}

function sendLog(params) {
    if (isProduction() && (!params || !logUrl)) {
        return;
    }
    // todo
    if (!isProduction()) {
        logUrl = 'https://dev10.umu.cn/hm2.gif';
        params = params || {};
    }

    try {
        var queryString = setQueryParams(params);
        var urlWithParams = `${logUrl}?${queryString}`;
        var img = new Image();
        img.src = urlWithParams;
        img.onerror = function () {
            console.error('sendLog error1', queryString);
        };
        img.onload = function () {
            img.remove();
        };
    } catch (error) {
        console.error('sendLog error2', error);
    }
}

function info() {
    if (isEnableLog) {
        console.log.apply(console, arguments);
        return;
    }
}

function log() {
    if (isEnableLog) {
        console.log.apply(console, arguments);
        return;
    }
    sendLog({
        event: 'umu-upload',
        ...userInfo,
        ...arguments,
    });
}

function error() {
    console.error.apply(console, arguments);
}

function errorAndLog() {
    error(...arguments);
    log(...arguments);
}

module.exports = {
    log: log,
    info: info,
    error: error,
    errorAndLog: errorAndLog,
};
